import styled from "styled-components";

import { BORDER, WHITE, BLACK, DARK_GREY, LIGHT_GREY, BG_GREY, LIGHT_BLUE } from '../../const';

export const ListMenuBlockStyled = styled.div`
    display: none;
    grid-template-columns: 1fr 1fr;
    gap: 20px 44px;
    position: absolute;
    z-index: 150;
    background: ${WHITE};
    flex-wrap: wrap;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
    padding: 20px 35px 45px;
    border-radius: 5px;

    &.singleColumn {
        grid-template-columns: 1fr;
    }

    @media (max-width: 1200px) {
        box-shadow: none;
        position: static;
        width: 100%;
        background: ${BG_GREY};
        grid-template-columns: 1fr;
        padding: 10px 0 0;

        &::before {
            content: none;
        }
    }

    .blockItem {
        width: 260px;

        &:hover {
            * {
                color: ${LIGHT_BLUE} !important;
            }
        }

        @media (max-width: 1200px) {
            width: 100%;
            border-bottom: ${BORDER};
            padding: 3px;
            padding-left: 10px;
            &:last-child {
                margin-bottom: 0;
                border: none;
            }
        }

        &_title {
            font-weight: 400;
            font-size: 16px;
            line-height: 22px;
            color: ${BLACK};
            margin-bottom: 3px;
            white-space: normal;

            @media (max-width: 1200px) {
                font-size: 14px;
                line-height: 19px;
            }
        }

        &_description {
            font-size: 12px;
            line-height: 16px;
            color: ${LIGHT_GREY};
            white-space: normal;

            @media (max-width: 1200px) {
                display: none;
            }
        }
    }
`;

export const ListMenuStyled = styled.div`
    display: flex;
    width: 100%;
    color: ${BLACK};
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    transition: all .75s;
    white-space: nowrap;


    a {
        color: ${DARK_GREY};
        transition: all .5s;
    }

    .listMenu_item {
        margin-right: 25px;
        cursor: pointer;
        position: relative;
        height: 50px;
        line-height: 50px;
        &:hover {
            border-bottom: 2px solid ${LIGHT_BLUE};
        }
        a:hover{
            color: ${LIGHT_BLUE};
            text-decoration: none;
        }
        &.active {
            a {
                color: ${LIGHT_BLUE};
            }

            &::before {
                content: "";
                border-top: 5px solid ${WHITE};
                border-top-color: ${LIGHT_BLUE} !important;

            }

            ${ListMenuBlockStyled} {
                display: grid;
            }

            &:not(:first-child) {
                ${ListMenuBlockStyled} {
                    &::before {
                        left: 50%;
                    }
                }
            }
        }


        &.hasSubcategories{
            .fa-chevron-down {
                margin-left: 7px;
                vertical-align: middle;
            }
        }

        @media (max-width: 1200px) {
            &::before {
                content: none;
            }
        }
    }

    @media (max-width: 1200px) {
        position: absolute;
        flex-wrap: wrap;
        top: 51px;
        left: 0;
        right: 0;
        background: ${BG_GREY};
        z-index: 150;
        padding-top: 15px;
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        margin-left: 0;

        .listMenu_item {
            width: 100%;
            margin: 0;
            padding: 7.5px 15px;
            border-bottom: ${BORDER};
            height: auto;

            a span {
                padding: 0;
            }

            &.hasSubcategories{
                span::after {
                    content: "";
                    width: 0;
                    height: 0;
                    border-left: 5px solid transparent;
                    border-right: 5px solid transparent;
                    border-top: 5px solid ${DARK_GREY};
                    position: relative;
                    top: 25px;
                    right: 25px;
                    float: right;
                    pointer-events: none;
                }

                padding-right: 0;
            }

            &.active {
                background: ${BG_GREY};

                a {
                    color: ${DARK_GREY};
                }

                span::after {
                    border-top: none;
                    border-bottom: 5px solid ${DARK_GREY};
                }

                border: none;
            }
        }

        span {
            padding-left: 15px;
        }
    }
`;
